export default "__VITE_ASSET__DTjUDt_Z__"